import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import superChatActions from 'ai/actions/superChatActions';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('ai/components/SuperChat/FeedbackCollection/locales', 'FeedbackCollection');

const localization = createStructuredSelector({
    thanksMessage: getTextFromResource(getText, 'thanksMessage'),
    close: getTextFromResource(getText, 'close')
});

const functions = {
    submitFeedback: superChatActions.submitFeedback
};

const fields = createSelector(localization, locales => {
    return {
        localization: locales
    };
});

const withFeedbackCollectionProps = wrapHOC(connect(fields, functions));

export {
    withFeedbackCollectionProps, fields, functions
};
